"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const aws_amplify_1 = require("aws-amplify");
class AuthRepositoryImpl {
    auth = aws_amplify_1.Auth;
    async currentSession() {
        const session = await this.auth.currentSession();
        return session;
    }
    async getUpdatedPayload() {
        const allData = await this.auth.currentAuthenticatedUser({
            bypassCache: true,
        });
        return allData?.signInUserSession?.accessToken?.payload;
    }
    async signUp(customer, password, participantId) {
        const params = {
            username: customer.email ?? '',
            password,
            attributes: {
                given_name: customer.name,
                phone_number: customer.mobile,
            },
        };
        if (participantId) {
            params.validationData = {
                participantId,
            };
        }
        await this.auth.signUp(params);
    }
    async confirmSignUp(email, code) {
        await this.auth.confirmSignUp(email, code);
    }
    async resendCodeSignUp(email) {
        await this.auth.resendSignUp(email);
    }
    async signIn(email, captcha, password) {
        const data = await this.auth.signIn(email, password, { token: captcha });
        const result = (await this.auth.signIn(email, password, { token: captcha }))
            .signInUserSession.idToken.payload;
        return {
            id: result.sub,
            name: result.given_name,
            status: result['custom:status'],
            nextAction: result['custom:nextAction'],
        };
    }
    async signOut() {
        await this.auth.signOut();
    }
    async forgotPassword(email) {
        await this.auth.forgotPassword(email);
    }
    async forgotPasswordSubmit(email, code, password) {
        await this.auth.forgotPasswordSubmit(email, code, password);
    }
    async changePassword(oldPassword, newPassword) {
        const user = await this.auth.currentAuthenticatedUser();
        await this.auth.changePassword(user, oldPassword, newPassword);
        await this.auth.signOut({ global: true });
    }
}
exports.default = AuthRepositoryImpl;
//# sourceMappingURL=AuthRepositoryImpl.js.map